import { useState } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'

import { MULT_GAME } from '~/statistics/constants'
import { MultiplicationMasterAPIStat } from '~/redux/apis/user-stats-api'

import ProductCardContainer from '../ProductCardContainer'

import MultGameSummary from './MultGameSummary'
import MultGameDetails from './MultGameDetails'

interface Props {
  product: MultiplicationMasterAPIStat
}

export default function StackNLoadProductCard({ product }: Props): React.ReactElement {
  const [showContent, setShowContent] = useState(false)

  const onToogle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName: MULT_GAME, expanded: !showContent })
    setShowContent(!showContent)
  }

  return (
    <ProductCardContainer>
      <MultGameSummary onClick={onToogle} showContent={showContent} timeSpent={product.timeSpent} />
      {showContent && <MultGameDetails product={product} />}
    </ProductCardContainer>
  )
}
